import { getCartItemTotalQuantity } from '@cart-services/core/cartService'
import { defaultStmCartValues, useStmCartStoreBase } from '@cart-services/hooks/use-stm-cart-store'
import { useStmBrandStore } from './use-stm-brand-store'

export const useStmAllBrandsCartQuantity = (): number => {
  const { brands } = useStmBrandStore()
  const cartState = useStmCartStoreBase()

  return brands.reduce((total, brand) => {
    const cart = cartState[brand.campaignId]?.cart ?? defaultStmCartValues.cart
    return total + getCartItemTotalQuantity(cart)
  }, 0)
}
